import { CurrencySelect } from '@/views/screens/common';
import { Col, Form, Row, Typography } from 'antd';
import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { useLocation } from 'react-router-dom';
import { USER_PREFERENCES } from '../../../../../../../../contants/common';
import useUserPreference from '../../../../../../../../redux/hooks/useUserPreference';
import { formateWithMoment } from '../../../../../../../../utilz/dates';
import { routeFileSelector } from '../../../../../../../../utilz/i18n';
import FormDatePicker from '../../../../../../../components/Inputs/FormDatePicker';
import HiddenFormInput from '../../../../../../../components/Inputs/HiddenFormInput';
import OverChargeClaimReasonSelector from '../../../../../../../components/Selectors/OverChargeClaimReasonSelector';
import OverChargeClaimStatusSelector from '../../../../../../../components/Selectors/OverChargeClaimStatusSelector';
import OverChargeClaimTypeSelector from '../../../../../../../components/Selectors/OverChargeClaimTypeSelector';
import TMSFiledCard from '../../../../../../common/components/TMSFiledCard';

const OurClaimForm = ({ editMode = true, claimDetails, form }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const submittedDate = Form.useWatch('dateSubmitted', form);
  const userDateFormat = useUserPreference(USER_PREFERENCES.DEFAULT_DATE_FORMAT);

  const onChangeClaimStatus = (data) => {
    if (data?.value === 'C') {
      form.setFieldsValue({ closedDate: moment(new Date()) });
    } else {
      form.setFieldsValue({ closedDate: undefined });
    }
  };
  return (
    <Row gutter={30}>
      <Col sm={6}>
        <CurrencySelect
          name="currencyCode"
          editMode={editMode}
          rules={[
            {
              required: true,
              message: t('translation:claims.pleaseSelectCurrency'),
            },
          ]}
          // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
          tabIndex={1}
        />
        <div className="mb-15">
          <TMSFiledCard title={t('translation:claims.ourClaim')}>{claimDetails?.customerClaimNo}</TMSFiledCard>
        </div>
        <div className="">
          <TMSFiledCard title={t('translation:claims.claimant')}>
            <span className="text-highlight fw-600">{claimDetails?.customerName}</span>
          </TMSFiledCard>
        </div>
      </Col>
      <Col sm={6}>
        <div className="mb-10 mt-5">
          <TMSFiledCard title={t('translation:default.fields.claimantAddress')}>
            <Typography.Paragraph style={{ whiteSpace: 'pre-line' }}>
              {String(claimDetails?.customerDisplayAddress ? claimDetails?.customerDisplayAddress : '').replace(
                '\r',
                '\n',
              )}
            </Typography.Paragraph>
          </TMSFiledCard>
        </div>
        <OverChargeClaimStatusSelector
          editMode={editMode}
          label={t('translation:default.fields.status.label')}
          name="statusCode"
          rules={[
            {
              required: true,
              message: 'Please select a status',
            },
          ]}
          // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
          tabIndex={2}
          onChange={onChangeClaimStatus}
        />

        <OverChargeClaimReasonSelector
          name="reasonCode"
          margin="mb-0"
          label={t('translation:default.fields.reason.label')}
          editMode={editMode}
          // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
          tabIndex={3}
        />
      </Col>
      <Col sm={6}>
        <OverChargeClaimTypeSelector
          name="ocTypeKey"
          label={t('translation:default.fields.type')}
          editMode={editMode}
          rules={[
            {
              required: true,
              message: t('translation:default.documentManager.documentManager.message'),
            },
          ]}
          // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
          tabIndex={4}
        />
        <div className="mb-15">
          <TMSFiledCard title={t('translation:claims.overchargeSum')}>
            <span className="text-danger fw-800">
              <NumericFormat
                thousandsGroupStyle="lakh"
                displayType="text"
                value={String(claimDetails?.overchargeSum ? claimDetails?.overchargeSum : 0)}
                thousandSeparator
                fixedDecimalScale
                decimalScale={2}
              />
            </span>
          </TMSFiledCard>
        </div>
        <div className="mb-30 mt-5">
          <TMSFiledCard title={t('translation:default.fields.auditedBy')}>{claimDetails?.preparedBy}</TMSFiledCard>
          <HiddenFormInput name="auditedBy" />
        </div>
      </Col>
      <Col sm={6}>
        <div className="mb-30 mt-5">
          <TMSFiledCard title={t('translation:default.fields.preparedBy')}>{claimDetails?.preparedBy}</TMSFiledCard>
        </div>
        <div className="mb-15">
          <TMSFiledCard title={t('translation:default.fields.submittedBy')}>{claimDetails?.submittedBy}</TMSFiledCard>
        </div>
        {editMode ? (
          <FormDatePicker
            name="dateSubmitted"
            editMode={Boolean(editMode)}
            margin="m-0"
            label={t('translation:default.fields.submittedDate')}
            allowClear={false}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={5}
          />
        ) : (
          <TMSFiledCard title={t('translation:default.fields.submittedDate')}>
            {submittedDate ? formateWithMoment(submittedDate, userDateFormat) : ''}
          </TMSFiledCard>
        )}
        <HiddenFormInput name="dateSubmitted" />
      </Col>
    </Row>
  );
};

export default OurClaimForm;
